module.exports = __webpack_public_path__ + "static/media/CircularStd-Book.c47d7e58.woff";